import { render, staticRenderFns } from "./Notif.vue?vue&type=template&id=1fa0ce26&scoped=true&"
import script from "./Notif.vue?vue&type=script&setup=true&lang=js&"
export * from "./Notif.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Notif.vue?vue&type=style&index=0&id=1fa0ce26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa0ce26",
  null
  
)

export default component.exports